import { render, staticRenderFns } from "./DataExtractionPage.vue?vue&type=template&id=2a1664c3&"
import script from "./DataExtractionPage.vue?vue&type=script&lang=js&"
export * from "./DataExtractionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports